/**
 * Everything the agent needs from the outside world, as interfaces. The app implements them with Capacitor plugins;
 * tests implement them in memory. Nothing in this package may import a browser, Node or Capacitor API directly, so
 * the core keeps running if the shell around it changes.
 */
/** Every storage collection the agent uses. One name per kind of record, so two features never share one by accident. */
export const Collection = {
    chat: "chat",
    contacts: "contacts",
    engagements: "engagements",
    episodes: "episodes",
    inboxCursor: "inbox_cursor",
    inboxSeen: "inbox_seen",
    outbox: "outbox",
    outboxSeq: "outbox_seq",
};
/** Reply length when a caller does not ask for one: enough for a chat answer, short enough for a phone. */
export const DEFAULT_MAX_TOKENS = 256;
/** In-memory implementations for tests and the web preview. */
export class MemoryStorage {
    data = new Map();
    bucket(c) {
        const existing = this.data.get(c);
        if (existing)
            return existing;
        const fresh = new Map();
        this.data.set(c, fresh);
        return fresh;
    }
    async get(c, id) {
        return this.bucket(c).get(id);
    }
    async put(c, id, v) {
        this.bucket(c).set(id, v);
    }
    async delete(c, id) {
        this.bucket(c).delete(id);
    }
    async list(c) {
        return [...this.bucket(c).values()];
    }
}
export class NoModel {
    async generate() {
        return null;
    }
}
export class SystemClock {
    now() {
        return new Date();
    }
}
//# sourceMappingURL=ports.js.map